<template>
  <div class="outer-wrapper">
      <div class="title">
        <p>壳体流程管理</p>
    </div>
    <Tabs>
      <TabPane label="全部壳体" icon="logo-buffer">
        <shell-list
          :columnsFormatData="columnsFormatData"
          :askData="askData"
          :refreshData="update_count"
          main_width="1280px"
        ></shell-list>
      </TabPane>
      <Button @click="openModal('newCreate')" slot="extra" type="primary" style="margin-right:5px;">新增壳体</Button>
      <Button @click="openModal('delMany')" slot="extra" type="primary" style="margin-right:5px;">批量删除</Button>
      <Button @click="openModal('alterMany')" slot="extra" type="primary">工序记录</Button>
    </Tabs>
    <Modal
      v-model="modalValue.newCreate"
      :width="600"
      :mask-closable="false"
    >
        <i
          class="ivu-icon ivu-icon-ios-close"
          slot="close"
          @click="closeModal('newCreate')"
        ></i>
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>新建壳体</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <table class="cr-form">
            <tr>
              <td>编号前缀：</td>
              <td>
                <input
                  type="text"
                  placeholder="例：KHA"
                  v-model="newItem.prefix"
                  style="width:200px;"
                  @change="autoInput"
                />
              </td>
            </tr>
            <tr>
              <td>编号范围：</td>
              <td>
                <input
                  type="text"
                  placeholder="首序号"
                  v-model.number="newItem.snBegin"
                  style="width:92px;"
                />
                ~
                <input
                  type="text"
                  placeholder="尾序号"
                  v-model.number="newItem.snEnd"
                  style="width:92px;"
                />
              </td>
            </tr>
            <tr>
              <td>材料入库编号：</td>
              <td>
                <select v-model="newItem.matnum" style="width:200px;">
                  <option :value="ele.matnum" v-for="ele in matList" :key="ele.matnum+'mat'">{{ele.matnum}}</option>
                </select>
              </td>
            </tr>
            <tr>
              <td>图号：</td>
              <td>
                <input
                  type="text"
                  placeholder=""
                  v-model="newItem.drawNo"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>设计压力(MPa)：</td>
              <td>
                <input
                  type="text"
                  placeholder=""
                  v-model="newItem.pressure"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>容积(L)：</td>
              <td>
                <input
                  type="text"
                  placeholder=""
                  v-model="newItem.volume"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>热处理方式：</td>
              <td>
                <input
                  type="text"
                  placeholder=""
                  v-model="newItem.heat_type"
                  style="width:200px;"
                  list="heat"
                />
                <datalist id="heat">
                    <option :value="ele.heat_type" v-for="ele in heatList" :key="ele.heat_type+'heat'"/>
                </datalist>
              </td>
            </tr>
            <tr>
              <td>制造起始日期：</td>
              <td>
                <input
                  type="date"
                  placeholder=""
                  v-model="newItem.startdate"
                  style="width:200px;"
                />
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="newCreateSubmit('newCreate')" :disabled="shellCreateValid" >提交</Button>
        <Button size="large" @click="closeModal('newCreate')" >取消</Button>
      </div>
    </Modal>
    <Modal
      v-model="modalValue.delMany"
      :width="600"
      :mask-closable="false"
    >
    <i
          class="ivu-icon ivu-icon-ios-close"
          slot="close"
          @click="closeModal('delMany')"
        ></i>
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>批量删除壳体</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <table class="cr-form">
            <tr>
              <td>编号前缀：</td>
              <td>
                <input
                  type="text"
                  placeholder="例：KHA"
                  v-model="delItem.prefix"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>编号范围：</td>
              <td>
                <input
                  type="text"
                  placeholder="首序号"
                  v-model.number="delItem.snBegin"
                  style="width:92px;"
                />
                ~
                <input
                  type="text"
                  placeholder="尾序号"
                  v-model.number="delItem.snEnd"
                  style="width:92px;"
                />
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="delManySubmit('delMany')" :disabled="delManyValid" >提交</Button>
        <Button size="large" @click="closeModal('delMany')" >取消</Button>
      </div>
    </Modal>
    <Modal
      v-model="modalValue.alterMany"
      :width="600"
      :mask-closable="false"
    >
    <i
          class="ivu-icon ivu-icon-ios-close"
          slot="close"
          @click="closeModal('alterMany')"
        ></i>
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>批量添加壳体工序记录</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <table class="cr-form">
            <tr>
              <td>选择工序：</td>
              <td>
                <select v-model="manyShell.process" style="width:200px;" @change="getValidRange">
                  <option :value="ele" v-for="ele in processList" :key="ele.label">{{ele.name}}</option>
                </select>
              </td>
            </tr>
            <tr>
              <td>编号前缀：</td>
              <td>
                <input
                  type="text"
                  placeholder="例：KHA"
                  v-model="manyShell.prefix"
                  style="width:200px;"
                  @change="getValidRange"
                />
              </td>
            </tr>
            <tr>
              <td>可选编号范围：</td>
              <td>
                <div style="width:300px;word-wrap:break-word;">
                  {{manyShell.validRange}}
                </div>
                
              </td>
            </tr>
            <tr>
              <td>编号范围：</td>
              <td>
                <input
                  type="text"
                  placeholder="首序号"
                  v-model.number="manyShell.snBegin"
                  style="width:92px;"
                />
                ~
                <input
                  type="text"
                  placeholder="尾序号"
                  v-model.number="manyShell.snEnd"
                  style="width:92px;"
                />
              </td>
            </tr>
            <tr>
              <td>日期：</td>
              <td>
                <input
                  type="date"
                  placeholder=""
                  v-model="manyShell.targetdate"
                  style="width:200px;"
                />
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="alterManySubmit('alterMany')" :disabled="alterManyValid" >提交</Button>
        <Button size="large" @click="closeModal('alterMany')" >取消</Button>
      </div>
    </Modal>
    <Modal
      v-model="modalValue.shellAlter"
      :width="600"
      :mask-closable="false"
    >
    <i
          class="ivu-icon ivu-icon-ios-close"
          slot="close"
          @click="closeModal('shellAlter')"
        ></i>
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>更新内容</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <table class="cr-form">
            <tr>
              <td>当前编号：</td>
              <td>
                {{shell.pronum}}
              </td>
            </tr>
            <tr>
              <td>材料入库编号：</td>
              <td>
                <select v-model="shell.matnum" style="width:200px;">
                  <option :value="ele.matnum" v-for="ele in matList" :key="ele.matnum+'mat'">{{ele.matnum}}</option>
                </select>
              </td>
            </tr>
            <tr>
              <td>图号：</td>
              <td>
                <input
                  type="text"
                  placeholder=""
                  v-model="shell.draw_no"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>设计压力(MPa)：</td>
              <td>
                <input
                  type="text"
                  placeholder=""
                  v-model="shell.pressure"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>容积(L)：</td>
              <td>
                <input
                  type="text"
                  placeholder=""
                  v-model="shell.volume"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>热处理方式：</td>
              <td>
                <input
                  type="text"
                  placeholder=""
                  v-model="shell.heat_type"
                  style="width:200px;"
                  list="heat2"
                />
                <datalist id="heat2">
                    <option :value="ele.heat_type" v-for="ele in heatList" :key="ele.heat_type+'heat'"/>
                </datalist>
              </td>
            </tr>
            <tr>
              <td>制造起始日期：</td>
              <td>
                <input
                  type="date"
                  placeholder=""
                  v-model="shell.startdate"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>热处理日期：</td>
              <td>
                <input
                  type="date"
                  placeholder=""
                  v-model="shell.heatdate"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>机加工日期：</td>
              <td>
                <input
                  type="date"
                  placeholder=""
                  v-model="shell.machinedate"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>水压日期：</td>
              <td>
                <input
                  type="date"
                  placeholder=""
                  v-model="shell.pressuretestdate"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>壳体完工日期：</td>
              <td>
                <input
                  type="date"
                  placeholder=""
                  v-model="shell.completedate"
                  style="width:200px;"
                />
              </td>
            </tr>
            <tr>
              <td>AB类型：</td>
              <td>
                <select v-model="shell.abmod" style="width:200px;">
                  <option value="A">A</option>
                  <option value="AB">AB</option>
                </select>
              </td>
            </tr>
            <tr>
              <td>状态：</td>
              <td>
                <select v-model="shell.stat" style="width:200px;">
                  <option value="正常">正常</option>
                  <option value="报废">报废</option>
                </select>
              </td>
            </tr>
            <tr>
              <td>备注：</td>
              <td>
                <textarea
                  type="text"
                  placeholder=""
                  v-model="shell.remark"
                  style="width:200px;"
                />
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="shellAlterSubmit('shellAlter')" >提交</Button>
        <Button size="large" @click="closeModal('shellAlter')" >取消</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import shellList from "@/components/Common/ShellList.vue";
let authData = JSON.parse(localStorage.getItem("authData"));
let userToken = localStorage.getItem("current_user_token");
//import shellExpand from "./ShellExpand.vue";

function itemValue(){
    return {
        prefix:"",
        snBegin:"",
        snEnd:"",
        matnum:"",
        drawNo:"",
        pressure:"",
        volume:"",
        heat_type:"",
        startdate:null
    };
}

function manyShellAlter(){
    return {
        process:"",
        prefix:"",
        validRange:"",
        snBegin:"",
        snEnd:"",
        targetdate:null
    };
}

function shellAlter(){
  return {
    matnum:"",
    draw_no:"",
    volume:"",
    pressure:"",
    heat_type:"",
    startdate:null,
    heatdate:null,
    machinedate:null,
    pressuretestdate:null,
    completedate:null,
    batchnum:"",
    stat:"",
    order_num:"",
    abmod:"",
    remark:""
  };
}

export default {
  name: "shell",
  props: [],
  components: {
    shellList
  },
  data() {
    return {
      op_name: this.$options.name,
      askData: "shellList",
      update_count: 0,
      modalValue:{
          newCreate:false,
          shellAlter:false,
          delMany:false,
          alterMany:false,
      },
      newItem:itemValue(),
      matList:[],
      matListTotal:[],
      heatList:[],
      processList:[],
      pressureDict:{},
      volumeDict:{},
      shell:shellAlter(),
      delItem:itemValue(),
      manyShell:manyShellAlter(),
      columnsFormatData: [
        /*{
            type: 'expand',
            width: 30,
            render: (h, params) => {
                return h(shellExpand, {
                    props: {
                        row: params.row
                    }
                })
            }
        },*/
        {
          title: "编号",
          key: "pronum",
          align: "center"
        },
        {
          title: "材料批号",
          key: "matnum",
          width: 120,
          align: "center"
        },
        {
          title: "图号",
          key: "draw_no",
          width: 110,
          align: "center"
        },
        {
          title: "容积",
          key: "volume",
          width: 85,
          align: "center"
        },
        {
          title: "设计压力",
          key: "pressure",
          width: 85,
          align: "center"
        },
        {
          title: "制造起始日期",
          key: "startdate",
          width: 120,
          align: "center"
        },
        {
          title: "热处理方式",
          key: "heat_type",
          width: 100,
          align: "center"
        },
        {
          title: "下道工序",
          key: "process_stat_ch",
          width: 85,
          align: "center"
        },
        {
          title: "操作",
          align: "center",
          width: 150,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  style: { marginRight: "10px", color: "green" },
                  on: {
                    click: () => {
                      this.modalValue.shellAlter = true;
                      this.shell = params.row;
                    }
                  }
                },
                "修改"
              ),
              h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  style: { color: "red" },
                  on: {
                    click: () => {
                      this.confirmBox(params.row);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
        /*{
          title: "材质",
          key: "grade",
          width: 75,
          align: "center"
        },
        {
          title: "外径*厚度",
          width: 110,
          align: "center",
          render:(h,params)=>{
              return h('p',
              {},
              params.row.diameter+'*'+params.row.thickness

              );
          },
        },
        {
          title: "工序流程",
          key: "flow_name",
          align: "center"
        },
        
        
        
        
        {
          title: "热处理工艺",
          key: "des",
          align: "center",
          width: 80,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "solid",
                    size: "small"
                  },
                  style: {},
                  on: {
                    click: () => {
                      this.linkTo(params.row.file_url);
                    }
                  }
                },
                "下载"
              )
            ]);
          }
        }*/
      ]
    };
  },
  computed:{
    shellCreateValid:function(){
      if(this.newItem.prefix!==""&&
         this.newItem.snBegin!==""&&
        this.newItem.snEnd!==""&&
        this.newItem.matnum!==""&&
        this.newItem.drawNo!==""&&
        this.newItem.pressure!==""&&
        this.newItem.volume!==""&&
        this.newItem.heat_type!==""&&
        this.newItem.startdate
         ){
           return false;
         }else{
           return true;
         }
    },
    delManyValid:function(){
      if(this.delItem.prefix!==""&&
         this.delItem.snBegin!==""&&
        this.delItem.snEnd!==""
         ){
           return false;
         }else{
           return true;
         }
    },
    alterManyValid:function(){
      if(this.manyShell.prefix!==""&&
         this.manyShell.snBegin!==""&&
        this.manyShell.snEnd!==""&&
        this.manyShell.targetDate!==null
         ){
           return false;
         }else{
           return true;
         }
    }

  },
  created(){
    this.getStaticOptionsData();
  },
  methods: {
    getStaticOptionsData(){
      this.$axios
        .post(this.$url + "/ask_static_options", {
          userToken: userToken,
          ask_data: 'shellOption',
        })
        .then(response => {
          if (response.data.stat === "ok") {
            this.matList = response.data.res_record.matList;
            this.matListTotal = JSON.parse(JSON.stringify(this.matList));
            this.heatList = response.data.res_record.heatList;
            this.pressureDict = response.data.res_record.pressureDict;
            this.volumeDict = response.data.res_record.volumeDict;
            this.processList = response.data.res_record.processList;
          }else{
            this.$Message.warning('请求选项数据失败！');
          }
        })
        .catch(error => {
          this.$Message.warning(error + "网络错误！操作失败。");
        });
    },
    getValidRange(){
      if(this.manyShell.process&&this.manyShell.prefix){
      this.$axios
        .post(this.$url + "/ask_static_options", {
          userToken: userToken,
          ask_data: 'alterManyShellValidRange',
          item:this.manyShell
        })
        .then(response => {
          if (response.data.stat === "ok") {
            this.manyShell.validRange = response.data.res_record.validRange;
          }else{
            this.$Message.warning('请求选项数据失败！');
          }
        })
        .catch(error => {
          this.$Message.warning(error + "网络错误！操作失败。");
        });
      }
    },
    autoInput(){
      let volumeNo = this.newItem.prefix.charAt(2).toUpperCase();
      let pressureNo = this.newItem.prefix.charAt(1).toUpperCase();
      if(this.volumeDict[volumeNo]!==undefined){
        this.newItem.volume = this.volumeDict[volumeNo].volume;
      }
      if(this.pressureDict[pressureNo]!==undefined){
        this.newItem.pressure = this.pressureDict[pressureNo].pressure;
        this.newItem.heat_type = this.pressureDict[pressureNo].heat_type;
      }
      this.matList = this.matListTotal.filter(val=>val.matnum.charAt(1)===pressureNo);
    },
    confirmBox(value) {
      this.$Modal.confirm({
        title: "确认删除：",
        content:
          "<p>" +
          "壳体：" +
          value.pronum +          
          "</p>",
        onOk: () => {
          this.recordFormatDel(value.pronum);
        },
        onCancel: () => {}
      });
    },
    recordFormatDel(id) {
      this.$axios
        .post(this.$url + "/process", {
          userToken: userToken,
          askData: "delShell",
          id: id
        })
        .then(response => {
          if (response.data.stat === "ok") {
            this.$Message.success("删除成功！");
            this.update_count++;
          }
        })
        .catch(error => {
          this.$Message.warning(error + "网络错误！操作失败。");
        });
    },
    linkTo(url) {
      window.open(this.$fileUrlFac(url, authData.sfileRight));
    },
    openModal(value){
        this.modalValue[value] = true;
    },
    closeModal(value){
        this.modalValue[value] = false;
    },
    newCreateSubmit(value){
        this.$axios
        .post(this.$url + "/process", {
          userToken: userToken,
          askData: "createShell",
          item: this.newItem   
        })
        .then(response => {
          if (response.data.stat == "ok") {
            this.$Message.success("新建成功！");
            this.newItem = itemValue();
            this.closeModal(value);
            this.update_count++;
          } else {
            this.closeModal(value);
            this.$Message.error(response.data.data.info);
          }
        }).catch(error=>{
            this.$Message.error("网络连接有误！"+error);
        });
    },
    delManySubmit(value){
      this.$axios
        .post(this.$url + "/process", {
          userToken: userToken,
          askData: "delManyShell",
          item: this.delItem
        })
        .then(response => {
          if (response.data.stat == "ok") {
            this.$Message.success("删除成功！");
            this.closeModal(value);
            this.delItem = itemValue();
            this.update_count++;
          } else {
            this.closeModal(value);
            this.$Message.error(response.data.data.info);
          }
        }).catch(error=>{
            this.$Message.error("网络连接有误！"+error);
        });
    },
    shellAlterSubmit(value){
        this.$axios
        .post(this.$url + "/process", {
          userToken: userToken,
          askData: "shellAlter",
          item: this.shell
        })
        .then(response => {
          if (response.data.stat == "ok") {
            this.$Message.success("修改成功！");
            this.closeModal(value);
            this.shell = shellAlter();
            this.update_count++;
          } else {
            this.closeModal(value);
            this.$Message.error(response.data.data.info);
          }
        }).catch(error=>{
            this.$Message.error("网络连接有误！"+error);
        });
    },
    alterManySubmit(value){
        this.$axios
        .post(this.$url + "/process", {
          userToken: userToken,
          askData: "alterManyShell",
          item: this.manyShell
        })
        .then(response => {
          if (response.data.stat == "ok") {
            this.$Message.success("修改成功！");
            this.closeModal(value);
            this.manyShell = manyShellAlter();
            this.update_count++;
          } else {
            this.closeModal(value);
            this.$Message.error(response.data.data.info);
          }
        }).catch(error=>{
            this.$Message.error("网络连接有误！"+error);
        });
    },
  }
};
</script>
<style scoped>
.outer-wrapper{
    width:1280px;
    margin:0 auto;
}
.title{
  text-align: center;
  margin:10px auto;
  font-size:20px;

}
.cr-form{
    width:100%;
    border-collapse: collapse;
}

.cr-form td{
    height:45px;
}

.cr-form td:first-child{
    text-align: right;
}

.cr-form input,.cr-form select{
    padding: 0 10px;
    outline: none;
    height:30px;
    border-radius: 2px;
    border:1px solid #aaa;
}

textarea{
  padding: 5px;
}
</style>